import { render, staticRenderFns } from "./BatchDelete.vue?vue&type=template&id=166f97d2"
import script from "./BatchDelete.vue?vue&type=script&lang=ts"
export * from "./BatchDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports